<template>
    <div>
      <nullView v-show="scoreTypeCode == '-1'" :message="scoreTypeMessage"  />
      <Layout :isNotLogin="false">
        <div class="wrap">
          <el-form ref="form" :model="form" :rules="rules" status-icon label-position="top" class="form">
            <div style="margin-top: 60px"></div>
            <p style="text-align: center;font-size: 0.48rem;">手机号登录</p>
            <div class="form-title">{{ name }}</div>
            <el-form-item class="form-item" label="手机号码" prop="account">
              <el-input type="text"  placeholder="请输入" maxlength="11" v-model="form.account"  />
            </el-form-item>
            <el-form-item class="form-item" label="验证码" prop="password">
              <div style="position: relative;">
                <el-input style="width: 60%;" type="text" maxlength="8" placeholder="请输入" v-model="form.password"  />
                <el-button class="form-code-btn" v-show="smsShowTime" @click="handlerSend">发送验证码</el-button>
                <el-button class="form-code-btn" disabled v-show="!smsShowTime" >{{sendTime}}秒</el-button>
              </div>
            </el-form-item>

            <el-form-item class="form-login-box">
              <el-button class="form-login-btn" type="text" v-on:click="onSubmit()">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </Layout>

    <el-dialog title="短信确认" :visible.sync="dialogVisible" width="500px">
      <div style="display: flex; justify-content: center;align-items: center;">
        <el-image style="flex: 1; max-width: 150px;" :src="imgForm.imgUrl" @click="resetImg" class="vertify_img" />
        <el-input
          style="flex: 1.5;" 
          v-model="imgForm.inputVal"
          type="text"
          clearable
          :maxlength="10"
          placeholder="请输入" >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getSmsCode">确定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    </div>
  </template>
  
  <script>
    import { isMobile } from '@/utils/generalFunTools'
    import { getVerifyCode, loginByMobile, postLogImg } from "@/api/mailBox";
    import nullView from './module/nullView.vue'
    import Layout from '../layout/Layout.vue'

    const CheckPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else {
        if (!isMobile(value)) {
          callback(new Error('手机号格式不正确'))
        } else {
          callback()
        }
      }
    }
  
    export default {
      name: 'mobileLogin',
      components: {
        nullView,
        Layout
      },
      data() {
        return {
          id: '',
          name: '',
          dialogVisible: false,   // 弹框显隐
          imgForm: {
            imgUrl: '', //验证码图片
            key: '',
            inputVal: ''
          },
          form: {
            account: '',
            password: ''
          },
          rules: {
            account: [
              {required: true, message: '请输入手机号码', trigger: 'blur'},
              { required: true, trigger: 'blur', validator: CheckPhone }
            ],
            password: [
              {required: true, message: '请输入验证码', trigger: 'blur'}
            ]
          },
          smsShowTime: true,
          sendTime: '',
          timer: null,
          scoreTypeCode: '',
          scoreTypeMessage: ''
        }
      },
      mounted() {
      },
      methods: {
        // 短信发送验证
        handlerSend() {
          this.resetImg()
          this.dialogVisible = true
        },
        // 获取验证码图片
        resetImg() {
          postLogImg().then(res => {
            if(res.code == '0') {
              this.imgForm.imgUrl = res.data.image
              this.imgForm.key = res.data.key
            }
          })
        },
        // 获取短信
        getSmsCode() {
          this.$refs['form'].validateField('account', valid => {
            if (valid) {
              this.$message.error(valid)
              this.dialogVisible = false 
              return false;
            }else {
              const pamras = {
                mobile: this.form.account,
                key: this.imgForm.key,
                verCode: this.imgForm.inputVal
              }

              getVerifyCode(pamras).then(res => {
                if(res.code == '0') {
                  this.dialogVisible = false
                  this.$message.success(res.message)
                  const TIME_COUNT = 60;
                  if (!this.timer) {
                    this.sendTime = TIME_COUNT;
                    this.smsShowTime = false;
                    this.timer = setInterval(() => {
                      if (this.sendTime > 0 && this.sendTime <= TIME_COUNT) {
                        this.sendTime--;
                      } else {
                        this.smsShowTime = true;
                        clearInterval(this.timer); // 清除定时器
                        this.timer = null;
                      }
                    }, 1000);
                  }
                }else {
                  this.resetImg()
                  this.$message.error(res.message)
                }
              })
            }
          })
        },
        onSubmit(type) {
          Object.keys(localStorage).forEach(key => {
            if(key.indexOf('MOBILE_USER_SCORE_DETAIL_STORAGE_') != -1) {
              localStorage.removeItem(key)
            }
            if(key.indexOf('MOBILE_USER_SCORE_SUMMARY_STORAGE_') != -1) {
              localStorage.removeItem(key)
            }
          })
          this.$refs['form'].validate((valid) => {
              if (valid) {
                loginByMobile(this.form).then(res => {
                  const {code,data} = res
                  
                  data['mobile'] = this.form.account
                  this.$store.dispatch('LoginAction', data)

                  // 获取query，有路由则跳转
                  let to = (this.$route.query && this.$route.query.redirect) ? this.$route.query.redirect : '/mailbox'
                  
                  // 根据是否有写信判断跳转路由
                  this.$router.replace({
                    path: to
                  })
                }).catch(err => {
                  
                })
              }
          })
        },
        logout() {
          this.$store.dispatch('LogoutAction')
          window.location.href="https://www.baidu.com"
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
    .title {
      width: 100%;
      height: 6.6vh;
      background: #044995;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      position: relative;
      .title-content {
        height: 20px;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        position: absolute;
        left: 36px;
        bottom: 12px;
      }
    }
    .button-box {
      display: flex;
      justify-content: flex-end;
      padding: 8px 0;
      width: 100%;
      .btn-end {
        margin-right: 14px;
      }
    }
    .wrap {
      // width: 100vw;
      // background: #F9F9F9;
      // box-shadow: 0rem 0.01rem 0.08rem 0rem rgba(0,0,0,0.05);
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      .form {
        width: 80%;
        height: 100%;
        @media screen and (min-width: 800px) {
          width: 50%;
        }
        &-title {
          font-size: 0.48rem;
          line-height: 0.56rem;
          font-weight: 500;
          text-align: center;
          margin-bottom: 0.3rem;
        }
        &-item {
          background: #fff;
          box-shadow: 0rem 0.01rem 0.08rem 0rem rgba(0,0,0,0.05);
          @media screen and (min-width: 800px) {
            // box-shadow: 0.03rem 0.02rem 0.08rem 0rem rgb(146, 145, 145);
          }
          /deep/ .el-form-item__label {
            padding: 0.24rem 0.4rem;
            line-height: unset;
            font-size: 0.26rem;
            display: block;
            line-height: 0.4rem;
          }
          /deep/ .el-input {
            line-height: 0.8rem;
            font-size: 0.24rem;
            height: 0.8rem;
          }
          /deep/ .el-input__inner {
            border: unset;
            margin-left: unset;
            line-height: 0.8rem;
            height: 0.8rem;
            padding: 0.24rem 0.4rem;
          }
          .form-code-btn {
            color: #fff;
            background-color: #044995;
            position: absolute;
            bottom: 0.4rem;
            right: 0.4rem;
          }
        }
        &-login-btn {
          width: 100%;
          background: #044995;
          color: #fff;
          height: 0.88rem;
          border-radius: 0.02rem;
          border: unset;
        }
        &-sms-btn {
          width: 1.48rem;
          flex: 0 0 1.48rem;
          padding: 0;
          height: 0.56rem;
          line-height: 0.56rem;
          background: #044995;
          border-radius: 0.02rem;
          border: unset;
        }
      }
      
      .form-login-box {
        .form-login-btn {
          width: 100%;
          height: auto;
        }
        /deep/ .el-button {
          font-size: 0.24rem;
        }
      }
    }
  </style>